document.addEventListener('DOMContentLoaded', async function() {
  if (window.scriptInitialized) return;
  window.scriptInitialized = true;
  const shopUrl = Shopify.shop;
  const fetchProductDetails = async (tag) => {
    const storefrontAccessToken = window.storefrontToken;
    const url = `https://${shopUrl}/api/2024-10/graphql.json`;

    const productQuery = `
            query Products($query: String!, $country: CountryCode) @inContext(country: $country) {
                products(first: 100, query: $query) {
                    edges {
                        node {
                            id
                            title
                            handle
                            discontinued: metafield(namespace: "custom", key: "discontinued") {
                                value
                                type
                            }
                            variantSwatchColor: metafield(namespace: "custom", key: "variant_swatch_color") {
                                value
                                type
                            }
                            totalInventory
                            priceRange {
                                maxVariantPrice {
                                    amount
                                    currencyCode
                                }
                                minVariantPrice {
                                    amount
                                    currencyCode
                                }
                            }
                            images(first: 2) {
                                edges {
                                    node {
                                        src
                                        altText
                                    }
                                }
                            }
                            variants(first: 100) {
                                edges {
                                    node {
                                        id
                                        title
                                        quantityAvailable
                                        compareAtPrice {
                                            amount
                                            currencyCode
                                        }
                                        selectedOptions {
                                            name
                                            value
                                        }
                                        image {
                                            src
                                            altText
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: productQuery,
          variables: {
            query: `tag:${tag}`,
            country: Shopify.country,
          },
        })
      });

      const { data, errors } = await response.json();

      if (errors) {
        console.error("GraphQL Errors:", errors);
        return null;
      }

      if (data && data.products.edges) {
        const productDetails = data.products.edges
          .map(({ node }) => {
            if (node) {
              return node;
            } else {
              console.warn("Encountered a null product.");
              return null;
            }
          })
          .filter(Boolean);

        return productDetails;
      } else {
        console.warn("No product data found.");
        return null;
      }
    } catch (error) {
      console.error("Error fetching product:", error);
      return []; // Return an empty array on error to prevent breaking subsequent code
    }
  };

  const processProductDetails = async (
    product,
    keyArray,
    valArray,
    featuredImageId,
    productDataElements,
    productId,
    primaryImagesrc,
    secondaryImagesrc,
    mainHandle,
    uniqueColors,
    counter,
    productAvailable
  ) => {
    if (product && product.variants && product.variants.edges) {
      let storedVariants = JSON.parse(
        sessionStorage.getItem("natoriCustomVariants") || "{}"
      );
      let customVarList = storedVariants[productId]?.variants || [];
      for (const edge of product.variants.edges) {
        const variant = edge.node;
        const productQuan = productAvailable;
        if (variant) {
          let variantCustomId = parseInt(variant.id.split("/").pop());
          if (!customVarList.includes(variantCustomId)) {
            for (const option of variant.selectedOptions) {
              if (
                option.name.toLowerCase() === "color" ||
                option.name.toLowerCase() === "colour" ||
                option.name.toLowerCase() === "couleur"
              ) {
                const key = option.value;
                if (!uniqueColors.has(key) && counter.count < 6) {
                  uniqueColors.set(key, option);
                  if (option.value.length > 0) {
                    let swatchHtml = "";
                    let active = "";
                    let variantImage = "";
                    let variantUrl = "";
                    let srcset = "";
                    let variantId = parseInt(variant.id.split("/").pop());
                    if (variant) {
                      if (variantId === featuredImageId) {
                        active = "active";
                      }
                      if (primaryImagesrc) {
                        variantImage = primaryImagesrc;
                      }
                      variantUrl = `/products/${product.handle}?variant=${variantId}`;
                    }
                    const imageSizes = "{{ sizes }}".split(",");

                    if (variantImage) {
                      imageSizes.forEach((size) => {
                        const sizeArray = size.split("x");
                        const sizeX =
                          sizeArray[0] +
                          "x" +
                          (sizeArray[1] !== "0" ? sizeArray[1] : "");
                        srcset += `${variantImage.replace(
                          ".jpg",
                          `_${sizeX}.jpg`
                        )} ${sizeArray[0]}w, `;
                      });
                    }
                    let colorValue = key.toLowerCase().trim();
                    const customColorIndex = keyArray.indexOf(colorValue);
                    if (customColorIndex > -1) {
                      colorValue = valArray[customColorIndex];
                    }
                    let bgValue = false;
                    const swatchColor = product.variantSwatchColor?.value;
                    if (swatchColor) {
                      const swatchParts = swatchColor.split("-");
                      const lastPart =
                        swatchParts[swatchParts.length - 1].trim();
                      if (lastPart.includes("#")) {
                        colorValue = lastPart;
                      } else {
                        bgValue = lastPart;
                        colorValue = "var(--bg-body)";
                      }
                    } else {
                      if (colorValue.includes(".")) {
                        bgValue = colorValue;
                        colorValue = "var(--bg-body)";
                      }
                    }
                    const shopDomain = window.location.hostname;
                    const bgImageUrl = bgValue
                      ? `--option-color-image: url('//${shopDomain}/cdn/shop/files/${bgValue}');`
                      : "";
                    swatchHtml += `
                                            <div class="product-card-swatch ${active}"
                                                style="--option-color: ${colorValue}; ${bgImageUrl}" 
                                                data-srcset-2="${secondaryImagesrc}" 
                                                data-srcset="${variantImage}"
                                                data-href="${variantUrl}"
                                                data-quan="${productQuan}">
                                                <span class="visually-hidden">${key}</span>
                                            </div>
                                        `;
                    if (productDataElements) {
                      const existingSwatches =
                        productDataElements.querySelectorAll(
                          ".product-card-swatch"
                        );
                      const isSwatchExists =
                        existingSwatches.length > 0 &&
                        productDataElements.querySelector(
                          `.product-card-swatch[data-href="${variantUrl}"]`
                        );
                      if (!isSwatchExists && existingSwatches.length < 6) {
                        productDataElements.insertAdjacentHTML(
                          "beforeend",
                          swatchHtml
                        );
                        counter.count++;
                      }
                    }
                  }
                }
              }
            }
            if (counter.count >= 6) break;
            customVarList.push(variantCustomId);
          }
        }
      }

      storedVariants[productId] = { variants: customVarList };
      sessionStorage.setItem(
        "natoriCustomVariants",
        JSON.stringify(storedVariants)
      );

      if (uniqueColors.size > 5 && counter.count > 5) {
        const moreButtonHtml = `<div class="morebtn"><a href="${mainHandle}" intellisuggest="" ss-ps="">+ More</a></div>`;
        productDataElements.insertAdjacentHTML("beforeend", moreButtonHtml);
      }
    }
  };
  if (window.location.pathname.includes("/collections/")) {
    const productCards = document.querySelectorAll(".product-card-swatch");

    for (const card of productCards) {
      const prodOldSwatches = card.querySelector(".product-card-swatches");
      if (prodOldSwatches) {
        prodOldSwatches.innerHTML = "";
      }

      const productId = card.getAttribute("data-product-id");
      const productStyleNo = card.getAttribute("data-style-no");
      const color_settings = window["settings"];
      const settings = window[`settings_${productId}`];

      const customColorsArray = color_settings.color_swatches
        .split(",")
        .map((color) => {
          const [key, value] = color.split(":").map((part) => part.trim());
          return { key: key.toLowerCase(), value: value || "" };
        });

      const keyArray = customColorsArray.map((color) => color.key);
      const valArray = customColorsArray.map((color) => color.value);

      let productDetails;
      try {
        productDetails = await fetchProductDetails(productStyleNo);
      } catch (error) {
        console.error("Error fetching product details:", error);
        continue;
      }

      let uniqueColors = new Map();
      let counter = { count: 0 };
      for (const productDetail of productDetails) {
        const productAvailable = productDetail.totalInventory > 0;
        const discontinued = productDetail?.discontinued?.value === "true";
        if (productDetail && !discontinued && productAvailable) {
          let primaryImagesrc = "";
          let secondaryImagesrc = "";
          if (
            productDetail &&
            productDetail.images &&
            productDetail.images.edges
          ) {
            const images = productDetail.images.edges.map((edge) => edge.node);
            images.forEach((image, index) => {
              if (index === 0) {
                primaryImagesrc = image.src;
              }
              if (index === 1) {
                secondaryImagesrc = image.src;
              }
            });
          }
          await processProductDetails(
            productDetail,
            keyArray,
            valArray,
            settings.featured_image_id,
            document.getElementById("swatch_section_" + productId),
            productId,
            primaryImagesrc,
            secondaryImagesrc,
            settings.custom_handle,
            uniqueColors,
            counter,
            productAvailable
          );
          if (counter.count >= 6) break;
        }
      }
      var swatchSection = document.getElementById(
        "swatch_section_" + productId
      );
      if (swatchSection) {
        swatchSection.parentNode.parentNode.parentNode.enableSwatches();
      }
    }
  } else {
    setTimeout(async () => {
      const productCards = document.querySelectorAll(".product-card-swatch");

      for (const card of productCards) {
        const prodOldSwatches = card.querySelector(".product-card-swatches");
        if (prodOldSwatches) {
          prodOldSwatches.innerHTML = "";
        }

        const productId = card.getAttribute("data-product-id");
        const productStyleNo = card.getAttribute("data-style-no");
        const color_settings = window["settings"];
        const settings = window[`settings_${productId}`];

        const customColorsArray = color_settings.color_swatches
          .split(",")
          .map((color) => {
            const [key, value] = color.split(":").map((part) => part.trim());
            return { key: key.toLowerCase(), value: value || "" };
          });

        const keyArray = customColorsArray.map((color) => color.key);
        const valArray = customColorsArray.map((color) => color.value);

        let productDetails;
        try {
          productDetails = await fetchProductDetails(productStyleNo);
        } catch (error) {
          console.error("Error fetching product details:", error);
          continue;
        }

        let uniqueColors = new Map();
        let counter = { count: 0 };
        for (const productDetail of productDetails) {
          const productAvailable = productDetail.totalInventory > 0;
          const discontinued = productDetail?.discontinued?.value === "true";
          if (productDetail && !discontinued && productAvailable) {
            let primaryImagesrc = "";
            let secondaryImagesrc = "";
            if (
              productDetail &&
              productDetail.images &&
              productDetail.images.edges
            ) {
              const images = productDetail.images.edges.map(
                (edge) => edge.node
              );
              images.forEach((image, index) => {
                if (index === 0) {
                  primaryImagesrc = image.src;
                }
                if (index === 1) {
                  secondaryImagesrc = image.src;
                }
              });
            }
            await processProductDetails(
              productDetail,
              keyArray,
              valArray,
              settings.featured_image_id,
              document.getElementById("swatch_section_" + productId),
              productId,
              primaryImagesrc,
              secondaryImagesrc,
              settings.custom_handle,
              uniqueColors,
              counter,
              productAvailable
            );
            if (counter.count >= 6) break;
          }
        }
        var swatchSection = document.getElementById(
          "swatch_section_" + productId
        );
        if (swatchSection) {
          swatchSection.parentNode.parentNode.parentNode.enableSwatches();
        }
      }
    }, 2000);
  }
});
